import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FiUser,
  FiLock,
  FiEye,
  FiEyeOff,
  FiArrowRight,
} from "react-icons/fi";
import logo from "../img/tmis_logo_orig.png";
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const getInitials = (name = "") => {
    const initials = name
      .trim()
      .split(" ")
      .filter(Boolean)
      .map((word) => word[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();

    return initials || "U";
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!userName.trim() || !password.trim()) {
      setErrorMsg("Please enter username and password.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/login`, {
         userName: userName.trim(),
        email: userName.trim(),
        password,
      });

      if (response.data.success) {
        const user = response.data.user;
        const token = response.data.token;

        const loginUser = {
          ...user,
          initials: user.initials || getInitials(user.name),
        };

        if (rememberMe) {
          localStorage.setItem("user", JSON.stringify(loginUser));
          localStorage.setItem("authToken", token);
        } else {
          sessionStorage.setItem("user", JSON.stringify(loginUser));
          sessionStorage.setItem("authToken", token);
        }

        navigate("/dashboard");
      } else {
        setErrorMsg(response.data.message || "Login failed.");
      }
    } catch (error) {
      setErrorMsg(
        error.response?.data?.message || "Server error. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tmis-login-page">
      <header className="login-brand-header">
        <div className="login-brand">
          <Image src={logo} className="login-logo" alt="TMIS Logo" />

          <div className="login-brand-divider"></div>

          <div className="login-brand-title">
            <h1>Performance Assessment</h1>
            <p>Performance Management System</p>
          </div>
        </div>
      </header>

      <main className="login-main">
        <section className="login-card">
          <div className="login-card-header">
            <h2>Sign in</h2>
            <p>Please use your SEMS account to continue.</p>
          </div>

          {errorMsg && <div className="login-error">{errorMsg}</div>}

          <form onSubmit={handleLogin} className="login-form">
            <label className="login-field">
              <span>Username / Email</span>
              <div className="login-input-box">
                <FiUser />
                <input
                  type="text"
                  placeholder="Enter username or email"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  disabled={loading}
                  autoComplete="username"
                />
              </div>
            </label>

            <label className="login-field">
              <span>Password</span>
              <div className="login-input-box">
                <FiLock />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  autoComplete="current-password"
                />

                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  disabled={loading}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </label>

            <div className="login-options">
              <label className="remember-row">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  disabled={loading}
                />
                <span>Remember me</span>
              </label>

              <button type="button" className="forgot-btn" disabled={loading}>
                Forgot password?
              </button>
            </div>

            <button type="submit" className="login-submit-btn" disabled={loading}>
              {loading ? "Signing in..." : "Sign in"} {!loading && <FiArrowRight />}
            </button>
          </form>

          <p className="login-help">Need help? Please approach MIS.</p>
        </section>
      </main>
    </div>
  );
};

export default Login;